document.addEventListener('DOMContentLoaded', function () {
    const today = new Date().toISOString().split('T')[0];
    const storageKey = 'metalsRates_' + today;
    const cachedRates = localStorage.getItem(storageKey);

    var rateEl = document.getElementById('gold-rate');
    var barEl = document.querySelector('.announcement--bar slideshow-component > .headannunce');
    if (rateEl) {
      rateEl.style.display = "none";
      rateEl.style.opacity = 0;
    }
    if (barEl) {
      barEl.classList.remove('bottom-announcement-bar');
    }

    function showRateBox() {
      if (rateEl) {
        rateEl.style.display = "block";
        rateEl.style.opacity = 1;
      }
      if (barEl) {
        barEl.classList.add('bottom-announcement-bar');
      }
    }

    function hideRateBox() {
      if (rateEl) {
        rateEl.style.display = "none";
        rateEl.style.opacity = 0;
        rateEl.innerHTML = ""; 
      }
      if (barEl) {
        barEl.classList.remove('bottom-announcement-bar');
      }
    }
    var userCurrency = "CHF";

    function getCurrencySymbol(currencyCode) {
      try {
        return (0).toLocaleString(undefined, {
          style: "currency",
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).replace(/\d/g, '').trim();
      } catch (e) {
        return currencyCode;
      }
    }

    let currencySymbol = getCurrencySymbol(userCurrency);
    if (cachedRates) {
      const data = JSON.parse(cachedRates);
      updateRatesDisplay(data.goldgramRate, data.silvergramRate, data.currencySymbol);
      showRateBox();
      return;
    }
    var API_KEYS = [
           "sk_0A62b9832Bc192C44E8084e0FA67458F4162be9ace83330E",
           "sk_ed12f349069788B974057e8E686680b30cC5Ea76810D4b2f"                      
    ];

    function fetchWithFallback(keyIndex) {
      if (keyIndex >= API_KEYS.length) {
        hideRateBox();
        return;
      }

      var settings = {
        url: "https://gold.g.apised.com/v1/latest?metals=XAU,XAG&base_currency=CHF&currencies=CHF&weight_unit=gram",
        method: "GET",
        timeout: 0,
        headers: {
          "x-api-key": API_KEYS[keyIndex]
        }
      };

      $.ajax(settings).done(function (response) {
        if (response.status === "fail") {
          fetchWithFallback(keyIndex + 1);
          return;
        }
        if (response && response.data && response.data.metal_prices) {
          var metalPrices = response.data.metal_prices;
          var goldOpenPerGram = metalPrices.XAU && metalPrices.XAU.price;
          var silverOpenPerGram = metalPrices.XAG && metalPrices.XAG.price;

          if (goldOpenPerGram != null && silverOpenPerGram != null) {
            localStorage.setItem(storageKey, JSON.stringify({
              goldgramRate: goldOpenPerGram,
              silvergramRate: silverOpenPerGram,
              currencySymbol: currencySymbol
            }));
            updateRatesDisplay(goldOpenPerGram, silverOpenPerGram, currencySymbol);
            showRateBox();
          } else {
            hideRateBox();
          }
        } else {
          hideRateBox();
        }
      }).fail(function () {
        fetchWithFallback(keyIndex + 1);
      });
    }

    fetchWithFallback(0);

    function updateRatesDisplay(goldRates, silverRates, currencySymbols) {
      if (rateEl) {
        var goldLabel = rateEl.dataset.goldLabel || 'Gold';
        var silverLabel = rateEl.dataset.silverLabel || 'Silver';
        rateEl.textContent =
          `${goldLabel}: ${currencySymbols} ${goldRates.toFixed(2)}/g | ${silverLabel}: ${currencySymbols} ${silverRates.toFixed(2)}/g`;
      }
    }
  });
